/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: 'us-east-1',
  aws_cloud_logic_custom: [
    {
      name: 'oshiAPI',
      endpoint:
        'https://nti2kzqcsl.execute-api.us-east-1.amazonaws.com/devthree',
      region: 'us-east-1',
    },
  ],
  aws_cognito_identity_pool_id:
    'us-east-1:5fe52857-ff5d-4c23-9d56-cd3d9105f281',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_b7u9g2MDs',
  aws_user_pools_web_client_id: '4ljec7u6r9qfj2jc01au1iqroa',
  oauth: {},
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_dynamodb_all_tables_region: 'us-east-1',
  aws_dynamodb_table_schemas: [
    {
      tableName: 'authsessions-devthree',
      region: 'us-east-1',
    },
    {
      tableName: 'cacheddata-devthree',
      region: 'us-east-1',
    },
    {
      tableName: 'extradata-devthree',
      region: 'us-east-1',
    },
    {
      tableName: 'multimediameta-devthree',
      region: 'us-east-1',
    },
    {
      tableName: 'patientactivities-devthree',
      region: 'us-east-1',
    },
    {
      tableName: 'queueschedule-devthree',
      region: 'us-east-1',
    },
  ],
  aws_user_files_s3_bucket: 'multimediaff96a-devthree',
  aws_user_files_s3_bucket_region: 'us-east-1',
};

export default awsmobile;
